import { FaIdBadge as FuncoesIcon } from 'react-icons/fa'

import { Funcao, PermissaoTipo } from '@core/models/entities'
import { useAuth, useFetch } from '@presentation/hooks'
import { TablePage } from '@presentation/components/templates'
import { PageProps } from '@presentation/types/components/templates'
import {
  Filter,
  FilterProps,
  TableColumn,
  TableProps
} from '@presentation/types/components/organisms'

import {
  AddFuncaoModal,
  DeleteFuncaoModal,
  EditFuncaoModal,
  ReactivateFuncaoModal
} from './components'

const FuncoesPage: React.FC = () => {
  const { hasPermission } = useAuth()
  const { data, isFetching, totalItems, fetchData } = useFetch({
    path: '/funcoes',
    options: { sortBy: 'nome' },
    queries: {
      status: 1
    }
  })

  const pageConfigs: PageProps = {
    icon: <FuncoesIcon />,
    title: 'Funções',
    description: 'Página de gerenciamento de funções do campus.',
    actions: hasPermission(PermissaoTipo.Escrita)
      ? [<AddFuncaoModal onAdd={fetchData} />]
      : []
  }

  const filters: Filter[] = [
    {
      type: {
        value: 'nome',
        label: 'Nome'
      },
      description: {
        type: 'input',
        configs: {
          type: 'text'
        }
      }
    }
  ]

  const filterConfigs: FilterProps = {
    filters,
    fetchData,
    defaultQueries: {
      status: 1
    }
  }

  const columns: Array<TableColumn<Funcao>> = [
    {
      name: 'Nome',
      selector: funcao => funcao.nome,
      sortable: true,
      center: true,
      grow: 4
    },
    {
      name: 'Ações',
      cell: funcao => (
        <>
          {funcao.status ? (
            <>
              {hasPermission(PermissaoTipo.Escrita) && (
                <EditFuncaoModal id={funcao.id} onEdit={fetchData} />
              )}
              {hasPermission(PermissaoTipo.Remocao) && (
                <DeleteFuncaoModal id={funcao.id} onDelete={fetchData} />
              )}
            </>
          ) : (
            <>
              {hasPermission(PermissaoTipo.Escrita) && (
                <ReactivateFuncaoModal
                  id={funcao.id}
                  onReactivate={fetchData}
                />
              )}
            </>
          )}
        </>
      ),
      center: true
    }
  ]

  const tableConfigs: TableProps = {
    columns,
    data,
    apiConfigs: {
      totalItems,
      fetchData,
      isFetching
    }
  }

  return (
    <TablePage
      pageConfigs={pageConfigs}
      filterConfigs={filterConfigs}
      tableConfigs={tableConfigs}
    />
  )
}

export default FuncoesPage
